import { makeStyles, mergeClasses } from "@fluentui/react-components";
import { customTokens } from "@1js/acui-theme";
import type {
  AppTabListOverflowMenuItemState,
  AppTabListOverflowMenuState,
} from "./AppTabListOverflowMenu.types";

export const useMenuStyles = makeStyles({
  portal: {
    zIndex: 99999,
  },
});

export const useOverflowMenuStyles = makeStyles({
  menuPopover: {
    minWidth: "82px",
    maxHeight: "200px",
  },
  menuList: {
    backgroundColor: customTokens.colorNeutralBackground1,
  },
  menuButton: {
    maxWidth: "32px",
    minWidth: "32px",
    height: "32px",
    ":hover": {
      backgroundColor: customTokens.colorNeutralBackground3Hover,
    },
    ":active:hover": {
      backgroundColor: customTokens.colorNeutralBackground3Pressed,
    },
  },
  menuIcon: {
    width: "12px",
    height: "12px",
    fill: customTokens.colorNeutralForeground2,
  },
  wrapper: {
    display: "contents",
  },
});

export const useAppTabListOverflowMenuStyles = (
  state: AppTabListOverflowMenuState
) => {
  const styles = useOverflowMenuStyles();

  state.menuPopover.className = mergeClasses(
    styles.menuPopover,
    state.menuPopover.className
  );

  state.menuList.className = mergeClasses(
    styles.menuList,
    state.menuList.className
  );

  state.trigger.className = mergeClasses(
    "ms-ButtonNext",
    styles.menuButton,
    state.trigger.className
  );

  state.triggerIcon.className = mergeClasses(
    styles.menuIcon,
    state.triggerIcon.className
  );

  state.menuListWrapper.className = mergeClasses(
    styles.wrapper,
    state.menuListWrapper.className
  );

  return state;
};

export const useOverflowMenuItemStyles = makeStyles({
  root: {
    minWidth: "90px",
  },
});

export const useAppTabListOverflowMenuItemStyles = (
  state: AppTabListOverflowMenuItemState
) => {
  const styles = useOverflowMenuItemStyles();

  state.root.className = mergeClasses(styles.root, state.root.className);

  return state;
};
